import { request } from '../axios/request';

import {
  FETCH_TRANSFER_STOCK_LOCATIONS_PENDING,
  FETCH_TRANSFER_STOCK_LOCATIONS_REJECTED,
  FETCH_TRANSFER_STOCK_LOCATIONS_FULFILLED,
} from '../constants/transferStockLocations';

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);
const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_TRANSFER_STOCK_LOCATIONS_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_TRANSFER_STOCK_LOCATIONS_FULFILLED,
  response,
});

const rejected = (error) => ({
  type: FETCH_TRANSFER_STOCK_LOCATIONS_REJECTED,
  error,
});

export const fetchTransferStockLocations = (id) => (dispatch) => {
  dispatch(pending());
  const usedStorage = localStorage.getItem('usedStorage');
  const remoteId = JSON.parse(usedStorage).remote_id;
  const isBrandKoton = $A.BRAND === 'Koton'

  const params = {
    id,
    erp_code: remoteId,
  };

  const url = isBrandKoton ? OMS.OMS.TRANSFER_STOCK_LOCATIONS_DESTINATION : OMS.OMS.TRANSFER_STOCK_LOCATIONS_V2

  request({
    method: 'get',
    url,
    params,
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });

};



// WEBPACK FOOTER //
// ./src/actions/transferStockLocations.js